module.exports = __webpack_public_path__ + "static/media/empty.34a89087.svg";